/* eslint-disable import/order */
import JiraHomeOnboardingRedirect from '@jira/spa-apps__common/src/JiraHomeOnboardingRedirect.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { homeOnboardingRedirectRoute } from '@jira/router-routes__home-onboarding-redirect-routes/src/homeOnboardingRedirectRoute.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const homeOnboardingRedirectRouteEntry: Route = createEntry(
	homeOnboardingRedirectRoute,
	() => ({
		group: 'home',
		// eslint-disable-next-line no-restricted-syntax
		component: JiraHomeOnboardingRedirect,
		layout: globalLayout,
		resources: [...getNavigationResources()],
		isRedirect: true,
		forPaint: [LazyAtlassianNavigation],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
